import { cva } from "class-variance-authority";

export const drawerHeaderVariants = cva(
  ` flex flex-row items-center gap-3 text-lg text-start p-6`,
  {
    variants: {
      variant: {
        default: "min-h-[4.5rem] text-primary-500",
        dark: "bg-primary-500 text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export const drawerContentVariants = cva(``, {
  variants: {
    variant: {
      default: "p-4",
      morePadding: "p-6",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});
